import { useContext } from 'react';
import { context as ConfigContext } from '../view/context/config';
import { Project, VariationBase } from '../generated/graphql';

const nullFunction = () => null;

const useEditor = ({
  variation,
  project,
}: {
  variation: VariationBase | undefined | null;
  project?: Pick<Project, 'id'> | undefined | null;
}) => {
  const config = useContext(ConfigContext);

  if (!variation) return nullFunction;

  const uri = config.EDITOR_URL;
  const editorType = variation.display_popup ? `popup/` : `ja/kz/`;
  const variationString = `?version=latest&variation_id=${variation.id}`;
  const returnUrl = `&return_url=${encodeURIComponent(window.location.href)}`;

  const openEditor = ({ editable = false, cloning = false }) => {
    const editableParam = editable ? `&mode=uneditable` : `&mode=editable`;

    if (cloning && !project) throw Error("You can't copy variation without project");
    const cloneParam = cloning ? `&clone=true&project_id=${project!.id}` : `&clone=false`;

    window.open(`${uri}/${editorType}${variationString}${returnUrl}${editableParam}${cloneParam}`);
  };

  return openEditor;
};

export default useEditor;
